import React, { Component } from 'react'
//import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import Button from '@material-ui/core/Button'
import { withRouter } from 'react-router-dom'
class Whoops extends Component {
    //   static propTypes = {
    //     prop: PropTypes
    //   }

    render() {
        return (
            <div>
                <Typography variant="h6" component="div">Something Went Wrong.</Typography>
                <p>Whoops! Something went wrong. Please wait a few moments and try again.</p>
                <Button color="primary" variant="contained" onClick={() => this.props.history.replace('/pages/'+this.props.pageName)} >Try Again</Button>
                <br />
                <br />
                <p>Still having trouble? Contact us at <Link url="mailto://support@braceability.com">support@braceability.com</Link> or <Link url="tel://866-712-7808">866-712-7808</Link></p>
            </div>
        )
    }
}
export default withRouter(Whoops)
